<style lang="less">
  .comm_action_bar { 
    min-height:48px; padding:7px 16px 0; box-sizing: border-box; background:#fff;
    .el-form--inline .el-form-item {margin-bottom:8px;}
    .el-input-group { width:300px !important;}
    .el-form-item__error { display: none  !important;}
    .el-form-item__content {line-height:32px;}
    .el-select,
    .el-input{
      vertical-align: middle;
    }
    .el-button--text {margin-bottom:0;}
    .el-date-editor .el-range-input {width:75px;}
    .el-date-editor .el-range-separator {width:24px;}

    & + .el-table {margin-top:16px;}

  }
</style>
<template>
  <div class="comm_action_bar">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'comm_action_bar',
  props: { },
  data: function() {
    return {
    }
  },

  created() {},

  mounted() {
    this.$nextTick(function() {
    })
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/commonplugin/common/comm_action_bar.vue